import { motion } from "framer-motion";

export const scrollToId = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Tag = ({ children, testId }) => (
  <div data-testid={testId} className="flex items-center gap-3 mb-6">
    <span className="w-2 h-2 bg-[#8A2BE2] rotate-45" />
    <span className="font-mono-file text-[11px] tracking-[0.3em] text-[#FFD166] uppercase">
      {children}
    </span>
  </div>
);

export const H2 = ({ children, className = "" }) => (
  <h2
    className={`font-display font-semibold text-3xl sm:text-4xl lg:text-[2.9rem] !leading-[1.1] text-white ${className}`}
  >
    {children}
  </h2>
);

export const GoldBtn = ({ children, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className="group inline-flex items-center gap-3 bg-[#FFD166] text-black font-display text-sm tracking-[0.18em] px-7 py-4 shadow-[5px_5px_0_#8A2BE2] hover:bg-[#F5CB5C] hover:shadow-[3px_3px_0_#8A2BE2] hover:translate-x-[2px] hover:translate-y-[2px] transition-[background-color,box-shadow,transform] duration-200"
  >
    {children}
  </button>
);

export const BrushHighlight = ({ children, className = "" }) => (
  <span className={`relative inline-block px-0 ${className}`}>
    <svg
      viewBox="0 0 150 40"
      preserveAspectRatio="none"
      aria-hidden="true"
      className="absolute -inset-x-1.5 -inset-y-2 w-[calc(100%+12px)] h-[calc(100%+16px)] -rotate-3"
    >
      <path
        d="M3,20 C1,16 2,12 6,11 C4,9 5,7 9,7 C30,5 70,8 110,5 C125,4 138,3 144,6 C149,8 149,13 146,15 C149,17 148,21 144,22 C147,25 145,29 140,29 C110,32 70,30 35,33 C18,34 8,35 4,32 C1,30 2,27 4,25 C1,24 1,22 3,20 Z"
        fill="#8A2BE2"
      />
      <path
        d="M8,13 C40,10 90,12 143,10"
        fill="none"
        stroke="#B685F5"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.4"
      />
      <path
        d="M6,26 C45,29 95,27 141,24"
        fill="none"
        stroke="#4C1D8C"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.35"
      />
    </svg>
    <span className="relative z-10 text-white">{children}</span>
  </span>
);

export const GhostBtn = ({ children, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className="font-display text-sm tracking-[0.18em] text-[#9D4EDD] border border-[#8A2BE2]/60 px-7 py-4 hover:bg-[#8A2BE2]/10 hover:border-[#9D4EDD] transition-colors duration-300"
  >
    {children}
  </button>
);
